<!-- OrderCodeDialog -->

<template>
  <van-dialog v-model="visibleCardInfo" :closeOnClickOverlay="true" :showConfirmButton="false" class="card-info">
    <van-swipe style="margin-bottom: 20px; margin-top: 20px">
      <van-swipe-item v-for="(card, index) in tickets" :key="index" class="card-info-item">
        <div class="title">
          消费券码{{ index + 1
          }}<span style="
              font-size: 22px;
              color: #999;
              font-weight: normal;
              margin-left: 4px;
            ">/{{ tickets.length }}</span>
        </div>

        <div class="sub-title" style="margin-bottom: -5px">
          <span>向商家出示券码消费,请勿泄露</span>
        </div>

        <!-- 展示不同形式的券码 -->
        <div :class="card.codeImage ? 'content-img' : 'content'">
          <span v-if="card.code" id="cardcode">{{ card.code }}</span>
          <a v-else-if="card.codeUrl" :href="card.codeUrl" target="_blank">打开链接查看</a>
          <van-image v-else-if="card.codeImage" :src="card.codeImage" height="100" width="100">
            <template v-slot:error>
              <a v-if="card.codeImage" :href="card.codeImage" target="_blank">打开链接查看</a>
            </template>
          </van-image>
        </div>

        <!-- 没有配置关键字和距离 才展示立即刷新 -->
        <div class="sub-title">
          <span v-if="show_refresh_code">为避免扫码失败,请使用前刷新券码 </span>
        </div>

        <!-- 入口后台配置了关键字和距离 就根据这个自动给真码 不展示立即刷新按钮 如果用户遇到问题就联系客服 -->
        <van-button v-if="show_refresh_code" style="margin-top: 10px" round size="small" type="danger"
          @click="refresh_order_code">立即刷新</van-button>

        <div style="margin-top: 25px; width: 100%; text-align: center">
          本消费券
          <span v-if="card.status === true" style="font-weight: bold; color: #ff3814">已消费</span>
          <span v-if="card.status === false" style="font-weight: bold; color: #42b983">未消费</span>
        </div>

        <div class="btn" style="margin-top: 15px">
          <van-button v-if="card.code" :data-clipboard-text="card.code" class="copy-orderid" round size="mini"
            type="default" @click="copy">复制券号</van-button>
          <span>&nbsp;&nbsp;</span>
          <!-- 间隔 -->
          <van-button v-if="card.status === false" round size="mini" type="danger" plain
            @click="updateStatus(card.orderTicketId, true)">标记为已消费</van-button>
          <van-button v-if="card.status === true" round size="mini" type="warning" plain
            @click="updateStatus(card.orderTicketId, false)">取消标记</van-button>
        </div>

        <div class="notice">
          自动状态同步可能延迟, 消费后可自行标记, 以免混淆
        </div>

        <div class="place-nearby">
          <template v-if="placeNearby.title">
            <span>离您最近的 {{ placeNearby.title }} 在 {{ placeNearby.address }},
            </span>
            <span @click="open_location" class="place-nearby-btn">
              点我导航</span>
          </template>
          <span v-else>未搜索到附近的店铺</span>
        </div>
      </van-swipe-item>
    </van-swipe>
  </van-dialog>
</template>

<script>
import { wx_get_goods_order_detail } from "@/api/goods-api";
import request from "@/util/axios";
import Clipboard from "clipboard";
import { Toast } from "vant";
import { get_user_poi_location_cached, wx_open_location } from "@/util/wxSdk";
import { wx_get_jsapi_ticket } from "@/api/user";
import { get_location_href } from "@/util/LocationUtil";

import { update_ticket_order_status } from "@/api/goods-api";

import { $wx_kefu_rc } from "@/util/wxSdk";

export default {
  data() {
    return {
      orderId: null,
      tickets: [],
      visibleCardInfo: false,

      show_refresh_code: false,
    };
  },

  methods: {
    go_kefu() {
      location.href = $wx_kefu_rc();
    },

    load_keyword_and_radius() {
      var lng = sessionStorage.getItem("USER_CURRENT_POI_LNG");
      var lat = sessionStorage.getItem("USER_CURRENT_POI_LAT");

      var formData = new FormData();
      formData.append("orderId", this.orderId);
      formData.append("lng", lng);
      formData.append("lat", lat);

      // 二次兑换
      request.post("/mall/keyword-and-radius", formData).then((res) => {
        budo_log.debug("#84 keyword-and-radius", formData);

        // 有这个配置 就不展示 立即刷新按钮
        this.show_refresh_code = !(res?.data?.keyword && res?.data?.radius);

        // 附近店铺信息
        this.placeNearby = res?.data;
      });
    },

    refresh_order_code() {
      Toast("正在刷新订单数据 ..");

      var formData = new FormData();
      formData.append("orderId", this.orderId);

      // 二次兑换
      request.post("/mall/ticket-order-exchange-2", formData).then((res) => {
        budo_log.info("#81 ticket-order-exchange-2", formData, res);

        if (res.code > 0) {
          Toast(res.msg || "已兑换,如有问题请联系客服 B");
          return;
        }

        Toast("请重新使用,如有问题请联系客服");

        // 重新获取订单信息 from-order-code-dialog 会记录查看日志
        wx_get_goods_order_detail(this.orderId, "from-order-code-dialog").then(
          (res) => {
            this.tickets = res?.data?.codes || [];
          }
        );
      });
    },

    copy() {
      const clipboard = new Clipboard(".copy-orderid");
      clipboard.on("success", (e) => {
        budo_log.info("#351 复制成功", e);
        Toast("复制成功");
      });
      clipboard.on("error", (e) => {
        budo_log.info("#357 该浏览器不支持复制", e);
        Toast("该浏览器不支持复制"); // 不支持复制
      });
    },

    // 入口方法
    showCardInfo(orderId) {
      budo_log.info("#294 dialog, showCardInfo, orderId=", orderId);

      this.tickets = [];
      this.orderId = orderId;
      this.visibleCardInfo = true;

      var href = get_location_href();

      wx_get_jsapi_ticket(encodeURIComponent(href)).then(
        (res) => {
          budo_log.info("#160 wx_get_jsapi_ticket res=", res);

          get_user_poi_location_cached(
            res,
            () => {
              budo_log.info("#163 get_user_poi_location_cached, res", res);
              this.get_order_info();
            },
            () => {
              budo_log.info("#166 get_user_poi_location_cached else");
              this.get_order_info();
            }
          );
        }
      );

      // 如果上面的方法没有回调 卡券信息没展示 这里就请求一遍
      // 如果上面的请求成功了 这里就冗余请求一遍
      setTimeout(() => {
        budo_log.info("#174 get_order_info in setTimeout");
        this.get_order_info();
      }, 3000);
    },

    open_location() {
      if (!this.placeNearby || !this.placeNearby.lng) {
        Toast("没有位置信息 ..");
        return;
      }

      Toast("打开地图 ..");

      var href = get_location_href();

      wx_get_jsapi_ticket(encodeURIComponent(href)).then(
        (res) => {
          budo_log.info("#165 open_location", res);

          this.placeNearby.name = this.placeNearby.title;
          wx_open_location(res, this.placeNearby);
        }
      );
    },

    // 拉取订单信息 供展示卡券
    get_order_info() {
      budo_log.debug("#183 get_order_info", this.orderId);

      // 重新获取订单信息
      wx_get_goods_order_detail(this.orderId, "from-order-code-dialog").then(
        (res) => {
          this.tickets = res?.data?.codes || [];
        }
      );

      this.load_keyword_and_radius(this.orderId);
    },

    updateStatus(id, status) {
      update_ticket_order_status(id, status).then((res) => {
        if (res.code === 0) {
          const ticket = this.tickets.find((t) => t.orderTicketId === id);
          if (ticket) {
            ticket.status = status;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card-info {
  text-align: center;

  .title {
    font-size: 28px;
    padding: 8px;
    font-weight: bold;
  }

  .sub-title {
    font-size: 12px;
    color: #666;
  }

  .content {
    padding: 16px;
    margin: 32px;
    background-color: #e9e9e9;
  }

  .content-img {
    padding: 8px;
    margin: 16px;
    background-color: #e9e9e9;
  }

  .btn {
    margin-top: 32px;
  }

  .notice {
    font-size: 12px;
    margin: 8px 16px;
    line-height: 30px;
    color: #999999;
  }

  .card-info-item {
    min-height: 350px;
  }
}

.place-nearby {
  margin: 8px 16px;
  font-size: 12px;
  color: #999999;
}

.place-nearby-btn {
  color: black;
}
</style>
